import { render, staticRenderFns } from "./IdpDomains.vue?vue&type=template&id=ad35017c&"
import script from "./IdpDomains.vue?vue&type=script&lang=js&"
export * from "./IdpDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports